import React from 'react';
import styled from "styled-components";
import SideMenu from '../layout/SideMenu';
import UserChat from '../layout/ChatContainer';
import PropTypes from "prop-types";
import {connect} from "react-redux";

const HomePage = ({selectedContact, selectedGroup}) => {
    return (
        <Container>
            <div className={`wrapper ${!!selectedContact || !!selectedGroup ? "wrapper-columns": null}`}>
                <div className="side-menu-container"><SideMenu/></div>
                <div className="user-chat-container"><UserChat/></div>
            </div>
        </Container>
    );
}

HomePage.propTypes = {
    selectedContact: PropTypes.object,
    selectedGroup: PropTypes.object,
};

const mapStateToProps = (state) => ({
    selectedContact: state.contact.selectedContact,
    selectedGroup: state.contact.selectedGroup,
});

export default connect(mapStateToProps)(HomePage);

const Container = styled.div`
  .wrapper {
    position: relative;
    height: 100vh;
    display: grid;
    grid-template-columns: 475px calc(100% - 475px);
    overflow: hidden;

    > div {
      background-color: #fff;
    }
  }

  @media screen and (max-width: 1000px) {
    .wrapper{
      grid-template-columns: 100% 0;
    }
    .wrapper-columns {
      grid-template-columns: 0 100%;
      
      .side-menu-container{
        //opacity: 0;
      }
    }
  }
`;